import { CtrlCollection } from "@yuigoto/ctrl";
import axios from "axios";
import { Tooltip } from "components/elements/Tooltip";
import { Info } from "components/icons/Info";
import { ControlRenderer } from "components/renderers/ControlRenderer";
import { DuvidasControl } from "controls/DuvidasControl";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { UiActions } from "state/actions/UiActions";
import { PartnerInfoActions } from "state/actions/user/PartnerInfoActions";
import { FileHandler2 } from "views/development/FileHandler2";
import Styles from "views/pages/ParticiparCampanhasMarcas.module.scss";

let files = [];

class DuvidasGlampartners extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // files: [],
      influencerHelpId: 0,
      helpData: {}
    }

  }


  renderFormContent = () => {
    this.collection = new CtrlCollection()

    for (let i in DuvidasControl) {
      if (Array.isArray(DuvidasControl[i])) {
        for (let n in DuvidasControl[i]) {
          this.collection.add(DuvidasControl[i][n])
        }
      }
      else {
        this.collection.add(DuvidasControl[i])
      }
    }

    return (
      <div className={"level-2"}>
        <div className={"gb-contentblock p-3 p-lg-4"}>
          <form onSubmit={this.sendHelp}>
            {ControlRenderer.renderCollection(this.collection)}
            <div >
              {this.renderUpload()}
            </div>
            <div className={"p-1 text-center"}>
              <button
                type={"submit"}
                className={"btn btn-sm btn-light-pink"}>
                Enviar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  sendHelp = (event) => {
    event.preventDefault();
    if (this.collection.validate()) {

      this.props.loaderShow();
      let helpData = this.collection.toObject(true);
      let requestBody = {
        help: helpData.help,
        influencerHelpTypeId: parseInt(helpData.influencerHelpTypeId)
      }

      ExecuteRequest(
        GlamboxEndpoints.Partner.createHelp,
        Object.assign({}, requestBody),
        "POST",
        {
          'Authorization': this.props.token
        },
        null,
        (response) => {
          const { result, statusCode } = response;

          if (statusCode === 200) {
            if (files.length > 0) {
              console.log(files)
              let helpData = requestBody;
              this.setState({
                helpData
              }, ()=>{this.sendFiles(result.influencerHelpId)});              
            }else{
              console.log(files)

              this.props.successAlert("Sua mensagem foi enviada, logo entraremos em contato com você.")
            }

          }
          this.props.loaderHide();

        }
      )
    } else {
      this.forceUpdate();
    }

  }

  sendFiles = (influencerHelpId) => {
    const { helpData } = this.state;

    const promises = [];
    const url = process.env.REACT_APP_GB_API_ROOT + "/partner/help/file/" + parseInt(helpData.influencerHelpTypeId) + "/" + influencerHelpId

    for (let file of files) {
      console.log(file)
      const formData = new FormData();
      formData.append("file", file, file.name);
      formData.append("influencerHelpTypeId", parseInt(helpData.influencerHelpTypeId));
      formData.append("influencerHelpId", influencerHelpId);
      formData.append("type", file.type);
      this.uploadFileRequest(formData, url);
    }
  }

  uploadFileRequest = (formData, url) => {
    this.props.loaderShow();
     axios.post(url,
      formData, {
      headers: {
        'Authorization': this.props.token
      },
      mode: 'no-cors'
    }).then(response => {
      files.length = 0;
      this.props.successAlert("Sua mensagem foi enviada, logo entraremos em contato com você.");

      console.log(response.data.result)
    }).catch(error => {
      console.log(error)
    });
    this.props.loaderHide();

  }

  renderUpload = () => {
    return (
      <div>
        <div className={Styles["more-details-upload"]}>
          <span >Caso tenha comprovantes ou imagens, pode realizar o upload <br /> para ajudar na solução do seu caso</span>
          <p> Requisitos da imagem
              <Tooltip position={"top"}
              label={"Formato jpg ou png"}>
              <Info className="_infoButton" fill={"#747F8B"} size={"16px"} />
            </Tooltip>
          </p>
          <div className={Styles["campaign-receipt-container"]}>
            {this.renderUploaded()}
          </div>
        </div>
      </div>
    )
  }

  renderUploaded = () => {
    const url = GlamboxEndpoints.Partner.createHelp.url;
    return (
      <div>
        <FileHandler2
          token={this.props.token}
          uploadUrl={`${process.env.REACT_APP_GB_API_ROOT}${url}`}
          finish={this.finish}
          multiple={true}
          returnFiles={true}
          multiple={true}
        />
      </div>
    );
  }
  finish = (newFiles) => {
    for (let file of newFiles) {
      files.push(file);
    }
  }

  render() {
    return (
      <div className={"p-2 p-lg-5"}>
        <Helmet>
          <title>Portal Glampartners : Atendimento Glampartners</title>
        </Helmet>
        <h1>Atendimento Glampartners</h1>
        {this.renderFormContent()}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    partner: state.partnerGeneral.data,
    token: state.token.data.Authorization
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    partnerUpdate: (partner, callback) => {
      dispatch(PartnerInfoActions.savePartnerData(partner, callback))
    },
    successAlert: (message) => {
      dispatch(UiActions.publishSuccessAlert(message))
    },
    errorAlert: (message) => {
      dispatch(UiActions.publishErrorAlert(message))
    },
    loaderShow: () => {
      dispatch(UiActions.loaderShow())
    },
    loaderHide: () => {
      dispatch(UiActions.loaderHide())
    }
  }
}
DuvidasGlampartners = connect(mapStateToProps, mapDispatchToProps)(DuvidasGlampartners)

export { DuvidasGlampartners };
